import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { Product } from './../interface/product/product';
import { HttpService } from './http/http.service';
import { MaterialRequirements } from '../interface';

@Injectable({
  providedIn: 'root'
})
export class MaterialRequirementsService {

  constructor(private _http: HttpService) { }

  public getAll(): Promise<MaterialRequirements[]> {
    return firstValueFrom(this._http.get('/MaterialRequirement'));
  }
  public add(data): Promise<MaterialRequirements> {
    return firstValueFrom(this._http.post('/MaterialRequirement', data));
  }
  public update(id: number, data: Product): Promise<MaterialRequirements> {
    return firstValueFrom(this._http.patch('/MaterialRequirement/', id, data));
  }
  public delete(id: number): Promise<MaterialRequirements> {
    return firstValueFrom(this._http.delete('/MaterialRequirement/', id));
  }
}
